module.exports = __webpack_public_path__ + "img/error.707b1725.svg";